var map = {
	"./ko.svg": 1051,
	"./loading.svg": 1052,
	"./ok.svg": 1053,
	"./spinner.svg": 1054
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1050;


//////////////////
// WEBPACK FOOTER
// ./src/images/icons ^\.\/.*\.svg$
// module id = 1050
// module chunks = 0